import {
  useMemo,
  forwardRef,
} from "react"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { useGetGlucoseValueAsPercentage } from "../hooks"
import { useFollowedUsers } from "src/contexts"

type Props = ComponentPropsWithoutRef<"div">

export const NormalRange = forwardRef<HTMLDivElement, Props>(
  function NormalRange(props: Props, propsRef: Ref<HTMLDivElement>) {
    const { currentFollow } = useFollowedUsers()
    const getGlucoseValueAsPercentage = useGetGlucoseValueAsPercentage()

    const {
      range_normal_bottom: normalRangeBottom,
      range_normal_top: normalRangeTop,
    } = currentFollow.display_settings

    const [normalRangeTopPercentage] = normalRangeTop === undefined
      ? [NaN]
      : getGlucoseValueAsPercentage(normalRangeTop)

    const [normalRangeBottomPercentage] = normalRangeBottom === undefined
      ? [NaN]
      : getGlucoseValueAsPercentage(normalRangeBottom)

    const normalRangeStyles = useMemo(
      () => ({
        bottom: `${normalRangeBottomPercentage}%`,
        top: `${100 - normalRangeTopPercentage}%`,
      }),
      [
        normalRangeTopPercentage,
        normalRangeBottomPercentage,
      ],
    )

    if (normalRangeBottom === undefined || normalRangeTop === undefined) {
      return null
    }

    return (
      <div
        id="normal-range-line"
        {...props}
        ref={propsRef}
        style={normalRangeStyles}
      />
    )
  },
)
